export const siteInfo = {
  name: "瓜乐圈",
  slogan: "轻松吃瓜，快乐加倍",
  intro: "瓜乐圈是一个轻松向的福利吃瓜内容站，把名场面、爆笑高能、小甜瓜和乐子合集整理到一起，专治无聊时刻。",
  email: "hello@gualequan.com",
  contactEmail: "contact@gualequan.com",
  joinEmail: "join@gualequan.com",
  since: "2019",
  readers: "48万",
  dailyPicks: "12",
  startYear: 2019,
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "名场面", to: "/category/mingchangmian" },
  { label: "爆笑高能", to: "/category/baoxiao" },
  { label: "小甜瓜", to: "/category/xiaotiangua" },
  { label: "乐子合集", to: "/category/lezi" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

export const footerColumns = [
  {
    title: "内容栏目",
    links: [
      { label: "名场面", to: "/category/mingchangmian" },
      { label: "爆笑高能", to: "/category/baoxiao" },
      { label: "小甜瓜", to: "/category/xiaotiangua" },
      { label: "乐子合集", to: "/category/lezi" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "常见问题", to: "/faq" },
      { label: "内容原则", to: "/about#principle" },
      { label: "读者口碑", to: "/about#voice" },
    ],
  },
];

export const tickerWords = [
  "今日更新 12 条乐子",
  "名场面 TOP10 已上线",
  "爆笑高能周榜刷新",
  "小甜瓜合集 · 甜度超标",
  "碎片时间随手刷一刷",
  "专治无聊时刻",
];